var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 259 283.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M56.151 198.757c-40.4-40.847-40.4-107.072 0-147.919a102.634 102.634 0 0 1 146.285 0c40.4 40.847 40.4 107.072 0 147.919l-73.143 73.96Z",
    fill: "#fff",
    stroke: "#6D4EE7",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M129.255 70.977c28.564 0 51.72 23.415 51.72 52.3s-23.156 52.3-51.72 52.3-51.72-23.419-51.72-52.3 23.156-52.3 51.72-52.3Z",
    fill: "#6D4EE7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    fill: "none",
    d: "M0 0h259v275H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker3);
export default __webpack_public_path__ + "static/media/marker3.40ee8cb04f81e0e4e2fd3798dfe621eb.svg";
export { ForwardRef as ReactComponent };